export default import.meta.ROLLUP_FILE_URL_J81tQNLolFZxNAq8kjsg4w